const hero_rings = [
  {
    value: 63,
    label: 'Compliance health',
    subtitle: 'composite',
    color: '#c45b0f'
  },
  {
    value: 56,
    label: 'Audit readiness',
    subtitle: 'evidence & findings',
    color: '#c62d1f'
  }
];

const control_signals = [
  { value: '63%', label: 'Compliance health', subtitle: 'Composite, evidence-backed', tone: 'amber' },
  { value: '56%', label: 'Audit readiness', subtitle: 'Evidence & findings', tone: 'red' },
  { value: '8', label: 'Open risks', subtitle: '2 escalated', tone: 'red' },
  { value: '4', label: 'Expired supplier docs', subtitle: 'Tax / BBBEE / insurance', tone: 'amber' },
  { value: '2', label: 'Overdue approvals', subtitle: 'Above delegated authority', tone: 'red' },
  { value: '2', label: 'Open incidents', subtitle: 'Security & privacy', tone: 'amber' },
  { value: '5', label: 'Unresolved audit findings', subtitle: 'Across audits', tone: 'amber' },
  { value: '5', label: 'Policy breaches', subtitle: 'Irregular / non-compliant', tone: 'red' },
  { value: '6', label: 'Regulatory deadlines', subtitle: 'Next 30 days', tone: 'amber' },
  { value: '3', label: 'High-risk suppliers/contracts', subtitle: '2 suppliers · 1 contracts', tone: 'amber' },
  { value: '4', label: 'Evidence gaps', subtitle: 'Backup / patch / DPA', tone: 'red' },
  { value: '2', label: 'Controls failing', subtitle: 'Test overdue', tone: 'red' }
];

const control_signal_routes = {
  'Compliance health': 'ReportsDashboard',
  'Audit readiness': 'AuditsRegister',
  'Open risks': 'RisksDashboard',
  'Expired supplier docs': 'SupplierRegister',
  'Overdue approvals': 'FinanceCompliance',
  'Open incidents': 'IncidentsCases',
  'Unresolved audit findings': 'AuditsRegister',
  'Policy breaches': 'ComplianceProcurement',
  'Regulatory deadlines': 'RegulatoryCalendar',
  'High-risk suppliers/contracts': 'SupplierRegister',
  'Evidence gaps': 'ItSecurity',
  'Controls failing': 'ControlsLibrary'
};

const needs_today_items = [
  { title: '4 supplier document(s) expired', subtitle: 'Payments blocked until renewed', icon: 'bi-truck', icon_class: 'is-red' },
  { title: '2 approval(s) above delegated authority', subtitle: 'Awaiting the right sign-off', icon: 'bi-pen', icon_class: 'is-orange' },
  { title: '2 risk(s) escalated to committee', subtitle: 'Residual above appetite', icon: 'bi-exclamation-triangle', icon_class: 'is-red' },
  { title: '4 evidence gap(s)', subtitle: 'Backup / patch / DR / DPA missing', icon: 'bi-inbox', icon_class: 'is-amber' },
  { title: '2 open incident(s)', subtitle: 'Security & privacy under management', icon: 'bi-bell', icon_class: 'is-amber' },
  { title: '5 policy breach indicator(s)', subtitle: 'Irregular / non-compliant activity', icon: 'bi-flag', icon_class: 'is-orange' }
];

const needs_today_routes = {
  '4 supplier document(s) expired': 'SupplierRegister',
  '2 approval(s) above delegated authority': 'FinanceCompliance',
  '2 risk(s) escalated to committee': 'RisksDashboard',
  '4 evidence gap(s)': 'ItSecurity',
  '2 open incident(s)': 'IncidentsCases',
  '5 policy breach indicator(s)': 'ComplianceProcurement'
};

const domain_health_rows = [
  { label: 'Suppliers', value: 50, target: 50, tone: 'red' },
  { label: 'Finance', value: 29, target: 29, tone: 'red' },
  { label: 'Risk (within appetite)', value: 88, target: 88, tone: 'green' },
  { label: 'Employees', value: 71, target: 71, tone: 'amber' },
  { label: 'IT security', value: 50, target: 50, tone: 'red' },
  { label: 'Data privacy', value: 70, target: 70, tone: 'amber' },
  { label: 'Training', value: 85, target: 85, tone: 'green' }
];

const domain_health_routes = {
  Suppliers: 'SupplierRegister',
  Finance: 'FinanceCompliance',
  'Risk (within appetite)': 'RisksDashboard',
  Employees: 'EmployeeRegister',
  'IT security': 'ItSecurity',
  'Data privacy': 'DataPrivacy',
  Training: 'TrainingProgram'
};

const department_cards = [
  { label: 'Marketing', value: 33, meta: '1 staff · 1 need action', tone: 'red', route_name: 'EmployeeRegister' },
  { label: 'IT', value: 60, meta: '1 staff · 1 need action', tone: 'red', route_name: 'EmployeeRegister' },
  { label: 'Finance', value: 64, meta: '2 staff · 1 need action', tone: 'red', route_name: 'EmployeeRegister' },
  { label: 'Operations', value: 75, meta: '1 staff · 1 need action', tone: 'amber', route_name: 'EmployeeRegister' },
  { label: 'Procurement', value: 100, meta: '1 staff · all compliant', tone: 'green', route_name: 'EmployeeRegister' },
  { label: 'HR', value: 100, meta: '1 staff · all compliant', tone: 'green', route_name: 'EmployeeRegister' }
];

export default {
  name: 'CommandCenter',
  data: () => ({
    hero_rings,
    control_signals,
    control_signal_routes,
    needs_today_items,
    needs_today_routes,
    domain_health_rows,
    domain_health_routes,
    department_cards
  }),
  methods: {
    navigate_to_route(route_name) {
      if (!route_name) {
        return;
      }

      this.$router.push({ name: route_name });
    },

    open_control_signal(signal) {
      const route_name = this.control_signal_routes[signal.label];

      if (!route_name) {
        return;
      }

      this.navigate_to_route(route_name);
    },

    open_needs_today_item(item) {
      const route_name = this.needs_today_routes[item.title];

      if (!route_name) {
        return;
      }

      this.navigate_to_route(route_name);
    },

    open_domain_health_item(domain) {
      const route_name = this.domain_health_routes[domain.label];

      if (!route_name) {
        return;
      }

      this.navigate_to_route(route_name);
    },

    open_department_card(department) {
      this.navigate_to_route(department.route_name || 'EmployeeRegister');
    }
  }
};
